export const DRAG_TYPE_ORDERING = 'ORDERING_ENTRY_ROW';
export const DRAG_TYPE_UNORDERED = 'UNORDERED_COLLECTION_ROW';
